import { Construtor } from './construtor';

export class Area implements Construtor<Area> {
    public idArea: number;
    public nomeArea: string;
    public index: number;

    constructor (object?: any) {

        if (object !== undefined) {

            if (object instanceof Area) {
                this.copyObject(object);
            } else {
                this.parseFromJson(object);
            }

            if (!this.modeloCompleto()) {
                return null;
            }

        }

        return this;
    }

    copyObject(area: Area): void {
        this.idArea = area.idArea;
        this.nomeArea = area.nomeArea;
    }

    parseFromJson(area: any): void {
        this.idArea = area.idArea;
        this.nomeArea = area.nomeArea;
    }

    modeloCompleto(): boolean {
        return this.nomeArea !== undefined;
    }

    getNewInstance(object?: any): Area {
        return new Area(object);
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/area.ts